import {ApiResponse} from "@/services/responses/ApiResponse";
import NProgress from "nprogress";
import { EventBus } from "@/pitprojekt/event-bus";
import _ from 'lodash'

export class Error extends ApiResponse {
    errors: object;

    constructor(message: string, status: number = 500, errors: object = [], autoSnackbar: boolean = true) {
        super(message, status);
        this.errors = errors;
        if (autoSnackbar && message) this.showSnackbar();
        NProgress.done();
    }

     getMessage(): string {
        let message: string = this.message;

        if (!(this.errors === undefined )) {
            message += "\n\n" + _.join( _.flattenDeep((_.map(this.errors, function(value, key) {return value;}))),  "\n");
        }



        return message;
    }

    showSnackbar() {
        if (this.message) EventBus.$emit('showSnackbarEvent', this.getMessage(), 'error');
    }

    public static showSnackbar(message: string): void {
        const successResponse = new Error(message, 500);
        successResponse.showSnackbar();
    }

    public static build(error: any): Error {
        let e:Error;
        if (error.response) {
            e = new Error(error.response.data.message, error.response.status);
            console.warn(e);
        } else if (error.request) {
            e = new Error('Nieprawidłowe zapytanie API', 404);
        } else {
            e = new Error(error.message);
            console.warn(e);
        }
        return e;
    }

}
